import { useEffect, useState } from "react";
import CoupoHeader from "./components/CouponHeader";
import CouponCards from "./components/CouponCards";
import { connect } from "react-redux";
import { fetchCoupons } from "../store/action";
import HandleCreateCoupon from "./HandleCreateCoupon";
import GetUserForRedeemCoupon from "./GetUserForRedeemCoupon";
import { useUser } from "utils/helpers/UserContext";
import { Authorities } from "props/authoritries";
import { SuperAdminStatusEnum } from '../../../props/enum';
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const ViewCoupons: React.FC<Props> = ({ onFetchCoupons, fetchCoupons }) => {
  const [activeSection, setActiveSection] = useState<
    "create" | "view" | "redeem" | null
  >(null);
  useEffect(() => {
    onFetchCoupons();
  }, []);
  const { authUser, action, superAdmin } = useUser();
  const isCreateCouponPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_COUPON));
  const isRedeemCouponPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.REDEEM_COUPON));
  const isViewCouponsPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.LIST_COUPON));
  return (
    <div className="h-[calc(100vh-2rem)]">
      <div className="bg-white flex flex-col h-full">
        <section className="CuoponHeader mx-4">
          <CoupoHeader
            clickedOnRedeemCupon={() => setActiveSection("redeem")}
            clickedOnGenerateCupon={() => setActiveSection("create")}
            clickedOnViewCupon={() => setActiveSection("view")}
          />
        </section>
        <section className="CuoponBody flex-1 overflow-auto scrollbar-hide px-4 pb-10">
          {activeSection === "create" && (
            <div>
              {isCreateCouponPermitted ? (
                <HandleCreateCoupon />
              ) : (
                <div className="text-primary-400 text-center h-[60vh] flex justify-center items-center">
                  You don't have the permission.
                </div>
              )}
            </div>
          )}
          {activeSection === "view" && (
            <>
              {isViewCouponsPermitted ? (
                <CouponCards couponData={fetchCoupons.coupon ?? []} />
              ) : (
                <div className="text-primary-400 text-center h-[60vh] flex justify-center items-center">
                  You don't have the permission.
                </div>
              )}
            </>
          )}
          {activeSection === "redeem" && (
            <>
              {isRedeemCouponPermitted ? (
                <GetUserForRedeemCoupon />
              ) : (
                <div className="text-primary-400 text-center h-[60vh] flex justify-center items-center">
                  You don't have the permission.
                </div>
              )}
            </>
          )}
        </section>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchCoupons: state.coupon.fetchCouponState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchCoupons: () => dispatch(fetchCoupons()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewCoupons);
